import React, {useRef} from "react";
import {mrbgStore} from "./mrbg/mrbgRedux";
import MrbgSignature from "./mrbg/MrbgSignature.jsx";
import MilanLogo from "./MilanLogo.jsx";

function Footer({mainStyle}){

  const
    ftr = useRef(),
    footerInfo = mrbgStore.getState().mrbgVars.footerInfo;

  return(
    <footer ref={ftr}>
      {
        Object.keys(footerInfo).length?
          <section id={mainStyle.footerBody} className={mainStyle.flexRowDesk}>
            {
              footerInfo.contactUs?
                <ul id={mainStyle.footerContactUs}>
                  {
                    Object.keys(footerInfo.contactUs).map((k, i)=>{
                      return(
                        <li key={i}>
                          <i className={footerInfo.contactUs[k].icon}></i>
                          {
                            footerInfo.contactUs[k].role=='address'?
                              <ul>
                                {
                                  footerInfo.contactUs[k].connection.map((v, j)=>{
                                    return <li key={j}>{v}</li>
                                  })
                                }
                              </ul>:
                              <div>
                                {
                                  footerInfo.contactUs[k].connection.map((v, j)=>{
                                    return <a href={`tel:${v}`} key={j}>{`${v.substring(0, 4)} ${v.substring(4, 7)} ${v.substring(7)}`}</a>
                                  })
                                }
                              </div>
                          }
                        </li>
                      )
                    })
                  }
                </ul>:
                ''
            }
            {
              footerInfo.socialMedia?
                <div id={mainStyle.footerSocial}>
                  {
                    Object.keys(footerInfo.socialMedia).map((key,j)=>{
                      return ( <a href={footerInfo.socialMedia[key].connection} className={footerInfo.socialMedia[key].icon} key={j}></a>  )
                    })
                  }
                </div>:
                ''
            }
            <div id={mainStyle.footerLogo}>
              <MilanLogo />
            </div>
          </section>:
          ''
      }
      <MrbgSignature {...{mainStyle}}/>
    </footer>
  )
}

export default Footer;